import { render, staticRenderFns } from "./BuildingType.vue?vue&type=template&id=4caf466c&scoped=true&"
import script from "./BuildingType.vue?vue&type=script&lang=ts&"
export * from "./BuildingType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4caf466c",
  null
  
)

export default component.exports